
<template>
    
        <mars-view class="main-content-container"><law-title :title="questionInfo.title" :issue-time="issueTime" :implement-time="implementTime" :valid-status="extPack.valid_status || ''" :font-size-setting="fontSizeSetting"></law-title><lawyer-card :answer="answer" :jump-url="faBaoLink"></lawyer-card><mars-view v-if="extra" class="law-revision"><mars-view class="title">法律修订</mars-view><mars-rich-text class="content" :nodes="extra"></mars-rich-text></mars-view><mars-view v-if="!extra" class="top-gap"></mars-view><mars-view v-if="preamble" class="preamble-box" id="section_1_0_0"><mars-view class="preamble-title">序言</mars-view><mars-rich-text :nodes="preamble" class="preamble-text"></mars-rich-text></mars-view><mars-view class="content-box"><mars-rich-text v-for="(item, idx) in showContent" :key="idx" :id="item.index" :nodes="item.text" :class="[item.type, 'content']"></mars-rich-text></mars-view><mars-view class="content-btm-text content"><mars-view>法律信息查、学、研、用，就到
            <mars-view class="content-btm-text-link" @click.native="toFabao"><mars-view class="bdparse-link"></mars-view>北大法宝。
            </mars-view></mars-view><mars-view>
            北大法宝（m.pkulaw.com）是全面、及时、专业、智能的一站式法律信息检索平台。
            该平台1985 年创始于北京大学法学院，多年来稳定高质的提供法律法规、司法案例、学术期刊、律所实务、英文译本、检察文书、行政处罚文书等全类型法律数据资源检索，为法学及法律各界人士提供综合知识服务。
            现已形成企业法治、智能立法、法治政府、智慧司法、法学教研等业务领域应用，以及类案检索、风险透镜、知识图谱、智能问答等各类法律人工智能解决方案。竭诚服务法治中国建设，助力“智慧法治”发展。
        </mars-view><mars-view>爱法律有未来！</mars-view></mars-view><mars-view class="intro-from" id="learn-more" data-serverid="17017" data-area="bdfb-contentend" @click.native="toDetail"><mars-view class="desc">
            以上内容来自于：{{ answer.user && answer.user.showInfo && answer.user.showInfo.name || '' }}
        </mars-view><mars-view class="more-box">
            了解更多<mars-view class="more-icon"></mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
import { formatTimeToDate } from '../../../pages/qalandpage/utils/util.js';
import lawyerCard from "./lawyer-card.vue";
import lawTitle from "./law-title.vue";
import { act } from '../../../static/utils/navigate';
import { inSightObservers } from '../../../common/js/repeatExposureLog.js';
export default {
  components: {
    'lawyer-card': lawyerCard,
    'law-title': lawTitle
  },
  props: {
    // 问题相关数据
    questionInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    // ext信息
    extPack: {
      type: Object,
      default() {
        return {};
      }
    },
    // 答主信息
    answer: {
      type: Object,
      default() {
        return {};
      }
    },
    // 发布时间
    issueTime: {
      type: String,
      default: ''
    },
    // 生效时间
    implementTime: {
      type: String,
      default: ''
    },
    content: {
      type: Array,
      value: []
    },
    extra: {
      type: String,
      value: ''
    },
    // 序言
    preamble: {
      type: String,
      value: ''
    },
    fontSizeSetting: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showContent() {
      if (!this.content) {
        return '';
      }
      let num = 50;
      let desc = '';
      while (num <= this.content.length + 50) {
        desc = this.content.slice(0, num);
        num += 50;
      }
      return desc;
    }
  },
  data() {
    return {
      faBaoLink: 'https://m.pkulaw.com'
    };
  },
  mounted() {
    this.$nextTick(() => {
      inSightObservers('#learn-more', '', {}, [], false, true, true, {
        threshold: 0.99
      });
    });
  },
  methods: {
    // 跳转法宝
    toFabao() {
      act({
        target: this.faBaoLink,
        type: 'webview'
      });
    },
    // 跳转详细信息页面
    toDetail() {
      let jumpUrl = this.questionInfo.jumpUrl;
      if (!jumpUrl) {
        return;
      }
      log.send && log.send({
        serverId: 17017,
        area: 'bdfb-contentend',
        action: 'click'
      });
      act({
        target: jumpUrl,
        type: 'webview'
      });
    }
  }
};
</script>

<style scoped>
.main-content-container {
  padding: 0 4.11vw;
}
.main-content-container .search-result-tip {
  margin-bottom: 4.35vw;
  font-size: 3.38vw;
  color: #555;
  line-height: 3.38vw;
}
.main-content-container .search-result-tip .blue {
  color: #3b6fff;
}
.main-content-container .law-revision {
  padding: 3.62vw 3.14vw 2.54vw;
  background: #f5f6f9;
  border-radius: 2.9vw;
  margin: 7.25vw 0 4.35vw;
}
.main-content-container .law-revision .title {
  font-family: PingFang SC;
  font-size: 3.86vw;
  color: #1e1f24;
  line-height: 3.86vw;
  font-weight: 700;
  padding-bottom: 1.33vw;
}
.main-content-container .law-revision .content {
  font-family: PingFang SC;
  font-size: 3.86vw;
  color: #50525c;
  line-height: 6.04vw;
}
.main-content-container .preamble-box,
.main-content-container .preamble-title {
  padding-bottom: 4.35vw;
}
.main-content-container .top-gap {
  height: 7.25vw;
}
.main-content-container .content-box {
  color: #1f1f1f;
}
.main-content-container .content-box .content {
  display: inline-block;
}
.main-content-container .section_1,
.main-content-container .section_2,
.main-content-container .section_3,
.main-content-container .preamble-title {
  display: block !important;
  font-family: PingFang SC;
  font-size: 4.35vw;
  color: #1f1f1f;
  line-height: 7.25vw;
  font-weight: 700;
}
.main-content-container .section_1,
.main-content-container .section_2,
.main-content-container .section_3 {
  margin-bottom: 4.35vw;
}
.main-content-container .clause + [class*="section_"] {
  margin-top: 4.35vw;
}
.main-content-container .clause,
.main-content-container .content-btm-text,
.main-content-container .preamble-text {
  font-family: PingFang SC;
  font-size: 4.35vw;
  color: #1e1f24;
  line-height: 7.25vw;
}
.main-content-container .content-btm-text {
  margin-top: 1.21vw;
}
.main-content-container .content-btm-text .content-btm-text-link {
  display: inline;
}
.main-content-container .content-btm-text .bdparse-link {
  display: inline-block;
  width: 3.86vw;
  height: 3.86vw;
  margin: 0 0.72vw;
  background: url('https://gss0.bdstatic.com/7051cy89Q1gCncy6lo7D0j9wexYrbOWh7c50/yt/bdsp/icon/link.png') no-repeat;
  background-size: contain;
  vertical-align: -0.48vw;
}
.main-content-container .clause {
  margin-bottom: 1.21vw;
}
.main-content-container .intro-from {
  margin-top: 5.8vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4.11vw 0;
  border-top: 0.16vw solid #edeef0;
  font-family: PingFang SC;
  font-size: 3.86vw;
  color: #848691;
  line-height: 3.86vw;
}
.main-content-container .intro-from .desc {
  vertical-align: middle;
}
.main-content-container .intro-from .more-box {
  color: #50525c;
}
.main-content-container .intro-from .more-box .more-icon {
  margin-left: 0.48vw;
  display: inline-block;
  width: 1.61vw;
  height: 2.98vw;
  background-size: 100% 100%;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/law-regulation/learn-more-icon.png');
}

</style>
